import {
  IconButton,
  IconButtonProps,
  Tooltip,
  TooltipProps,
} from "@mui/material";

interface Props extends Omit<IconButtonProps, "children"> {
  tooltip?: string;
  placement?: TooltipProps["placement"];
  tooltipProps?: TooltipProps;
  children: React.ReactNode;
}

export default function BaseIconButton({
  tooltip,
  placement = "top",
  tooltipProps,
  children,
  disabled,
  ...props
}: Props) {
  return (
    <>
      {!disabled && (
        <Tooltip title={tooltip} placement={placement} {...tooltipProps}>
          <IconButton {...props} disabled={disabled}>
            {children}
          </IconButton>
        </Tooltip>
      )}
      {disabled && (
        <IconButton {...props} disabled={disabled}>
          {children}
        </IconButton>
      )}
    </>
  );
}
